import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';

import useSelectedDate from './useSelectedDate';
import { dateNavigationPeriodAtom } from 'components/shared/DateNavigation/atoms';
import { Period } from 'components/shared/DateNavigation/DateNavigation';

export default function useSelectedDateRange() {
  const dateNavigationPeriod = useRecoilValue<Period | null>(
    dateNavigationPeriodAtom
  );
  const [selectedDate] = useSelectedDate();

  const hash = location.hash;
  const params = hash.split('&');
  params.shift();

  const getTimeUnit = () => {
    switch (dateNavigationPeriod) {
      case 'month':
        return 'month';
      case 'week':
      case 'workweek':
        return 'isoWeek';
      case 'day':
      default:
        return 'day';
    }
  };

  const timeUnit = getTimeUnit();
  const startDate = dateNavigationPeriod
    ? dayjs(selectedDate).startOf(timeUnit).format('YYYY-MM-DD')
    : null;
  const endDate = dateNavigationPeriod
    ? dayjs(selectedDate)
        .endOf(timeUnit)
        .subtract(dateNavigationPeriod === 'workweek' ? 2 : 0, 'days')
        .format('YYYY-MM-DD')
    : null;

  return {
    startDate,
    endDate
  };
}
